import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { downloadBlob } from '@/utils/download';
import type { DcrSummarySearch } from '../types/dcrSummary.types';

export async function downloadDcrSummary(params: DcrSummarySearch): Promise<void> {
  const res = await apiClient.get<Blob>(API.dcrSummary.export, {
    params,
    responseType: 'blob',
  });

  downloadBlob(res.data, `dcr-summary-${params.dateFrom}-to-${params.dateTo}.xlsx`);
}
